import React, { createContext, useContext, useState, useCallback } from 'react';

const BootContext = createContext(null);

const REQUIRED_SUBSYSTEMS = ['auth'];
const BOOT_PLAYED_KEY = 'vortx_boot_played';

export function useBootContext() {
    const ctx = useContext(BootContext);
    if (!ctx) return { panelPower: { header: 1, left: 1, right: 1, footer: 1, content: 1 }, bootActive: false, reportReady: () => {}, reportAuthResolved: () => {}, authResolved: true };
    return ctx;
}

export function BootProvider({ children, isRetro }) {
    const hasPlayed = sessionStorage.getItem(BOOT_PLAYED_KEY) === 'true';
    const [bootActive, setBootActive] = useState(isRetro && !hasPlayed);
    const [readySystems, setReadySystems] = useState([]);
    const [authResolved, setAuthResolved] = useState(false);
    const [panelPower, setPanelPower] = useState(
        isRetro && !hasPlayed
            ? { header: 0, left: 0, right: 0, footer: 0, content: 0 }
            : { header: 1, left: 1, right: 1, footer: 1, content: 1 }
    );

    const reportReady = useCallback((subsystem) => {
        setReadySystems(prev => {
            if (prev.includes(subsystem)) return prev;
            return [...prev, subsystem];
        });
    }, []);

    const reportAuthResolved = useCallback(() => setAuthResolved(true), []);

    const isFullyReady = REQUIRED_SUBSYSTEMS.every(s => readySystems.includes(s));

    const onBootComplete = useCallback(() => {
        setBootActive(false);
        setPanelPower({ header: 1, left: 1, right: 1, footer: 1, content: 1 });
        sessionStorage.setItem(BOOT_PLAYED_KEY, 'true');
    }, []);

    return (
        <BootContext.Provider value={{
            bootActive,
            panelPower,
            setPanelPower,
            reportReady,
            reportAuthResolved,
            authResolved,
            isFullyReady,
            onBootComplete,
        }}>
            {children}
        </BootContext.Provider>
    );
}
